import { Observable } from 'rxjs';
import { DeviceModel } from './device.model';
import { PartnerModel } from './company.model';

export interface Service {
  serviceId: number;
  partnerOid: string;
  packageId: number;
  locationId: number;
  deviceId?: number;
  endUserId?: number;
  term: string;
  priceInCents: number;
  createdBy: string;
  createdOn: string;
  activatedOn?: string;
  status: string;
  package?: Observable<Package | undefined>;
  device?: Observable<DeviceModel | undefined>;
  partner?: Observable<PartnerModel | undefined>;
}

export const ServiceStatus = {
  PENDING_ACTIVATION: 'Pending activation',
  ACTIVE: 'Active',
  PENDING_TERMINATION: 'Pending termination',
  TERMINATED: 'Terminated',
};

export interface ServiceResponseModel {
  services: Service[];
  numberOfItems: number;
}

export interface ServiceCreatedResponseModel {
  serviceId?: number;
}

export interface ServiceFiltersModel {
  partnerOid?: string;
  locationId?: number;
  deviceId?: number;
  limit: number;
  offset: number;
}

export interface CreationServicePayloadModel {
  partnerOid: string;
  packageCode: string;
  locationId: number;
  endUserId?: number;
  deviceId?: number;
  priceId: number;
  priceInCents?: number;
}

export interface CreationServiceResultModel {
  detail?: object[] | string;
  serviceId?: number;
}

export interface UpdateServicePayloadModel {
  locationId?: number;
  deviceId?: number;
}

export interface UpdateServiceResultModel {
  detail?: object[] | string;
}

export interface PackageFiltersModel {
  limit: number;
  offset: number;
}

export interface Package {
  partnerOid: string;
  packageCode: string;
  packageId: number;
  packageDescription: string;
  prices: Price[];
}

export interface Price {
  id: number;
  term: string;
  defaultPriceToConsumersInCents?: number;
  costFromXemexInCents: number;
}

export interface PackageResponseModel {
  packages: Package[];
  numberOfItems: number;
}
